import React from 'react';
import { Box, Typography, Grid, Paper, Button } from '@mui/material';
import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { getSharingStats, formatNumber } from '../utils/dashboardUtils';

/**
 * Dashboard paylaşım istatistikleri bölümü
 */
const SharingStatsSection = () => {
  const { t } = useTranslation();
  const sharingStats = getSharingStats(t);

  return (
    <Box className="sharing-stats">
      <Box className="sharing-stats-header">
        <Typography className="sharing-stats-title">
          En Çok Paylaşılan Formlar
        </Typography>
        <Button 
          variant="text"
          endIcon={<ArrowForwardIcon />}
          sx={{
            textTransform: 'none',
            color: '#4158D0',
            '&:hover': {
              background: 'rgba(65, 88, 208, 0.05)',
            }
          }}
        >
          Tümünü Gör
        </Button>
      </Box>

      <Grid container spacing={3}>
        {sharingStats.map((stat) => (
          <Grid item xs={12} md={4} key={stat.id}>
            <Paper 
              className="sharing-card"
              elevation={0}
              sx={{
                '--sharing-color': stat.color,
                '--sharing-bg': stat.bg
              }}
            >
              <Box className="sharing-icon">
                {stat.icon}
              </Box>
              <Box className="sharing-info">
                <Typography className="sharing-title">
                  {stat.title}
                </Typography>
                <Typography className="sharing-meta">
                  {formatNumber(stat.views)} görüntülenme
                </Typography>
              </Box>
              <Typography className="sharing-stats-value">
                {stat.shares}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SharingStatsSection;
